<template>
    <router-view/>
</template>

<script>
export default {
    name: 'Visionary'
}
</script>

<style>
:root {
    --bg: #0f1218;
    --canvas: #0b0f15;
    --panel: #17202e;
    --panel-2: #1c2738;
    --border: #2a3446;
    --muted: #9aa3b2;
    --text: #e7ebf3;
    --accent: #4ea1ff;
    /* Extra tokens used by components */
    --titlebar: linear-gradient(180deg, #151a24, #121723);
    --ruler-bg: #141a27;
    --ruler-tick: #2a3242;
    --scroll-thumb-hover: #202b3e;
    --panel-selected: #172033;
}

/* Light theme overrides */
:root[data-theme='light'] {
    --bg: #f7f9fc;
    --canvas: #ffffff;
    --panel: #ffffff;
    --panel-2: #f2f5fb;
    --border: #d5d9e3;
    --muted: #6b7280;
    --text: #27323f;
    --accent: #2563eb;
    --titlebar: linear-gradient(180deg, #f8fafc, #eef2f7);
    --ruler-bg: #f0f3f9;
    --ruler-tick: #cfd6e4;
    --scroll-thumb-hover: #c8d0e0;
    --panel-selected: #e6eefc;
}

* { 
    user-select: none;
    margin: 0;
    padding: 0;
}

body {
    background: var(--bg);
    padding: 0;
    margin: 0;
}
</style>
